module.exports = __webpack_public_path__ + "img/guidebook7.1785a6d7.png";